export default __webpack_public_path__ + "92b992c8b80ee9d08dff44529499bb3a.png";